import type { MailboxInfo } from "owa-client-types";
import { isAccountFeatureEnabled } from "owa-feature-flags";

export default function isOriginalGenWebQueryOnTypeExperienceEnabled(mailboxInfo: MailboxInfo): boolean {
    return (isAccountFeatureEnabled("sea-gwc-query-on-type", mailboxInfo) &&
        !isAccountFeatureEnabled("sea-gwc-query-on-type-with-7-results", mailboxInfo));
}
